

export const soraSteps = {
    title: '如何用 3 步使用 Sora 2 生成视频',
    sub: '几分钟内生成专业 AI 视频。直觉界面让每个人都能轻松完成视频生成。',
    items: [
      { num: '1', title: '步骤 1：选择输入方式', text: '选择文字转视频并提供详细提示，或图片转视频上传参考图片。描述运镜、动作与风格。' },
      { num: '2', title: '步骤 2：配置视频参数', text: '选择适合社媒或电影风格的比例与时长（最高 15 秒）。在渲染选项中平衡速度与质量。' },
      { num: '3', title: '步骤 3：生成与下载', text: '点击生成并预览结果。下载高质量视频，适用于社媒平台、创意项目或商用。' }
    ],
  };
